module.exports = __webpack_public_path__ + "img/crm_banner3.87c998fe.png";